// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3Krkq","select":"Header_select__31Rfi","clinic":"Header_clinic__1S3Fe"};